/** 除超级管理员外，可访问题库管理的普通用户 */
export const QUESTION_BANK_MANAGER_USERNAMES = new Set([
  'z170440',
  'qfqz2026',
  'vmbm0660',
  '905102282',
  'ompd0915',
  'liuce19962'
])

export function canManageQuestionBank(user) {
  if (!user) return false
  if (user.is_admin === 1) return true
  const username = user.username == null ? '' : String(user.username).trim()
  return QUESTION_BANK_MANAGER_USERNAMES.has(username)
}

export function getStoredUser() {
  try {
    return JSON.parse(localStorage.getItem('user') || '{}')
  } catch {
    return {}
  }
}

export function canCurrentUserManageQuestionBank() {
  return canManageQuestionBank(getStoredUser())
}
